import { NotificationType } from "../graphql/types/graphql";

export enum CimQueryImpactTypes {
  DOWN = "DOWN",
  REDUCED_REDUNDANCY = "REDUCED_REDUNDANCY",
  RESILIENCE_LOSS = "RESILIENCE_LOSS",
  NO_IMPACT = "NO_IMPACT",
  UNKNOWN = "UNKNOWN",
}

export enum CimQueryStatuses {
  NEW = "NEW",
  OPEN_RELATED = "OPEN_RELATED",
  OPEN_ACCEPTED = "OPEN_ACCEPTED",
  OPEN = "OPEN",
  UPDATED = "UPDATED",
  ABORTED = "ABORTED",
  CLOSED = "CLOSED",
}

export enum CimStatus {
  ABORTED = "Aborted",
  OPEN = "Open",
  CLOSED = "Closed",
}

export enum CimImpactType {
  NONE = "No_impact",
  DOWN = "Down",
  RESILIENCE_LOSS = "Resilience_loss",
  REDUCED_REDUNDANCY = "Reduced_redundancy",
  UNKNOWN = "Unknown",
}
export interface CimResult {
  notifications: NotificationType[];
}
export interface CimMajorDisruptionResult {
  majorDisruptionNotifications: NotificationType[];
}
